import Vue from 'vue'
import { AutoComplete, Modal } from 'ant-design-vue'
import { savePreviousData, errorService, instance } from '@/services/api'
import { filterGrid, filterTakeoff } from '@/services/grid'
import { projectAPIs } from '@/services/authConstantsV1'
import { AgGridVue } from 'ag-grid-vue'
import CurrencyRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import _ from 'lodash'

Vue.use(AutoComplete)
Vue.use(Modal)

export default Vue.extend({
  components: {
    'ag-grid-vue': AgGridVue,
  },
  template: `
        <div class="a-gcell certain-category-search-wrapper">
          <a-spin :spinning="loading">
            <a-auto-complete
              class="w-100 certain-category-search"
              size="small"
              v-model="value"
              :value="value"
              option-label-prop="title"
              style="width: 200px"
              @focus="savePreviousData(value)"
              @search="onSearch($event)"
              @select="saveData"
              ref="txt-autocomplete"
              :autoFocus="true"
              dropdown-class-name="certain-category-search-dropdown"
            >
              <template slot="dataSource">
                <a-select-option
                  key="-1"
                  title="new"
                  value="new"
                  style="text-decoration: underline;color:blue"
                >
                  <a class="view-all">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    Add New
                  </a>
                </a-select-option>
                {{ currentResult }}
                <a-select-opt-group
                  v-for="(result, index) in currentResult"
                  :key="index"
                >
                  <span slot="label" class="select-text">
                    {{ result.takeoffGrouping }}
                  </span>
                  <a-select-option
                    v-for="item in result.takeoffs"
                    :key="item.key"
                    :value="item.key"
                  >
                    <a-tooltip
                      placement="left"
                      :title="
                        item.takeoff +
                          ' - ' +
                          formatCurrency(item.unitCost) +
                          ' - ' +
                          item.unit +
                          ' - ' +
                          formatLife(item.life) +
                          '(' +
                          item.assetClass +
                          ')' +
                          ' - ' +
                          item.categoryCode
                      "
                    >
                      <a-row :gutter="10">
                        <a-col :span="7">
                          <span class="autocomplete-list">
                            {{ item.takeoff }}
                          </span>
                        </a-col>
                        <a-col :span="6">
                          <span class="autocomplete-list right">
                            {{ formatCurrency(item.unitCost) }}
                          </span>
                        </a-col>
                        <a-col :span="3">
                          <span class="autocomplete-list">
                            {{ item.unit }}
                          </span>
                        </a-col>
                        <a-col :span="5">
                          <span class="autocomplete-list" v-if="item.assetClass">
                            {{ formatLife(item.life) }} ({{ item.assetClass }})
                          </span>
                          <span class="autocomplete-list" v-else>
                            {{ formatLife(item.life) }}
                          </span>
                        </a-col>
                        <a-col :span="3">
                          <span class="autocomplete-list">
                            {{ item.categoryCode }}
                          </span>
                        </a-col>
                      </a-row>
                    </a-tooltip>
                  </a-select-option>
                </a-select-opt-group>
                <a-select-option
                  key="all"
                  value="viewAll"
                  class="show-all"
                  v-if="count > limit"
                >
                  <a class="view-all">
                    View all results
                  </a>
                </a-select-option>
              </template>
            </a-auto-complete>
          </a-spin>
          <a-modal
            title="Takeoff"
            :visible="visible"
            @ok="handleOk"
            @cancel="handleCancel"
            :maskClosable="false"
            centered
            :destroyOnClose="true"
            :width="1200"
            :height="800"
            :bodyStyle="{ padding: '5px 24px 10px !important', height: '50rem' }"
            :footer="null"
            wrapClassName="modal-wrap"
          >
            <a-input
              v-model="searchText"
              placeholder="Search Takeoffs/Takeoff Groupings"
              class="mb-2"
              @change="onChange"
            >
              <template slot="suffix">
                <a-button
                  type="link"
                  icon="close-circle"
                  :style="{ padding: '0px', fontSize: '18px' }"
                  @click="clearFilter"
                />
              </template>
            </a-input>
            <div class="table" style="height: 100%; box-sizing: border-box">
              <a-spin tip="Loading..." :spinning="loading">
                <div style="height: 100%; width: 100%">
                  <ag-grid-vue
                    :style="{ width, height }"
                    class="ag-theme-alpine"
                    id="takeoffTable"
                    :gridOptions="gridOptions"
                    @grid-ready="getData"
                    :animateRows="true"
                    suppressLoadingOverlay="true"
                    tooltipShowDelay="0"
                    :frameworkComponents="frameworkComponents"
                    @selection-changed="onSelectionChanged"
                  >
                  </ag-grid-vue>
                </div>
              </a-spin>
            </div>
          </a-modal>
        </div>
    `,

  data() {
    return {
      value: null,
      loading: false,
      currentResult: [],
      savePreviousData: savePreviousData,
      prevSearchKey: '',
      prevResult: [],
      role: null,
      takeoffData: undefined,
      visible: false,
      gridOptions: null,
      columnDefs: [],
      width: '100%',
      height: '46rem',
      list: [],
      count: 0,
      limit: process.env.VUE_APP_TAKEOFF_COUNT,
      searchText: undefined,
    }
  },
  beforeMount() {
    this.loadConfig()
  },
  created() {
    const user = JSON.parse(localStorage.getItem('userDetails'))
    this.role = user.role
    this.value = this.params.value
  },
  methods: {
    loadConfig() {
      const cellClassRules = {
        'show-cell': 'data.section === "col-span"',
      }
      this.frameworkComponents = {
        costPriceCellRenderer: CurrencyRenderer,
      }
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        singleClickEdit: false,
        stopEditingWhenGridLosesFocus: false,
        tooltipShowDelay: 0,
        rowSelection: 'single',
        defaultColDef: {
          resizable: false,
          sortable: true,
          editable: false,
          suppressMovable: true,
          singleClickEdit: false,
        },
      }
      this.columnDefs = [
        {
          headerName: 'Takeoff',
          field: 'takeoff',
          tooltipField: 'takeoff',
          width: 400,
          headerTooltip: 'Takeoff',
          sortable: false,
          floatingFilter: false,
          colSpan: params => {
            if (params.data.section === 'col-span') {
              return 6
            } else {
              return 1
            }
          },
          cellClassRules: cellClassRules,
        },
        {
          headerName: 'Unit Cost',
          field: 'unitCost',
          width: 60,
          headerTooltip: 'Unit Cost',
          sortable: false,
          floatingFilter: false,
          cellRenderer: 'costPriceCellRenderer',
        },
        {
          headerName: 'Unit',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          field: 'unit',
          width: 50,
          headerTooltip: 'Unit',
          sortable: false,
          floatingFilter: false,
        },
        {
          headerName: 'Life (In Years)',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          field: 'life',
          width: 60,
          headerTooltip: 'Life (In Years)',
          sortable: false,
          floatingFilter: false,
        },
        {
          headerName: 'Asset Class',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          field: 'assetClass',
          width: 60,
          headerTooltip: 'Asset Class',
          sortable: false,
          floatingFilter: false,
        },
        {
          headerName: 'Category Code',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          field: 'categoryCode',
          tooltipField: 'categoryCode',
          width: 80,
          headerTooltip: 'Category Code',
          sortable: false,
          floatingFilter: false,
        },
      ]
    },

    getData(params) {
      params.api.setColumnDefs(this.columnDefs)
      params.api.setRowData(this.list)
      params.api.sizeColumnsToFit()
    },

    onSearch(searchText) {
      const searchString = searchText
      if (!this.visible) {
        this.searchText = searchText
      }
      let url = `${
        this.params.colDef['cellRendererParams'].dropdownURL
      }${searchText.slice(0, 3)}`
      if (this.params.colDef.cellRendererParams.screen === 'Project') {
        url = `${projectAPIs.master.takeoff.add(
          this.$route.params.id,
        )}?search=${searchText.slice(0, 3)}`
      }
      if (
        (this.prevSearchKey !== searchText && searchText.length === 3) ||
        (!this.prevSearchKey && searchText.length >= 3)
      ) {
        this.currentResult = []
        this.prevSearchKey = searchText
        this.loading = true
        instance
          .get(`${url}`)
          .then(res => {
            const result = _.get(res.data, 'result', [])
            this.list = []
            this.prevResult = JSON.stringify(result)
            this.loading = false
            const oldData =
              this.prevResult.length > 0 && searchString
                ? JSON.parse(this.prevResult)
                : []
            if (this.params.colDef.cellRendererParams.name === 'takeoff_Name') {
              this.searchTakeoff(oldData, searchString)
            } else {
              const list = oldData.filter(x =>
                x[this.params.colDef.cellRendererParams.name]
                  .toLowerCase()
                  .includes(searchString.toLowerCase()),
              )
              this.currentResult = [...list]
            }
          })
          .catch(err => {
            this.loading = false
            errorService(err)
          })
      } else {
        const oldData =
          this.prevResult.length > 0 && searchText
            ? JSON.parse(this.prevResult)
            : []

        if (this.params.colDef.cellRendererParams.name === 'takeoff_Name') {
          this.searchTakeoff(oldData, searchString)
        } else {
          const list = oldData.filter(x =>
            x[this.params.colDef.cellRendererParams.name]
              .toLowerCase()
              .includes(searchString.toLowerCase()),
          )
          this.currentResult = [...list]
        }
      }
    },

    onChange(event) {
      this.getTakeoffs(event.target.value)
    },

    getTakeoffs(searchText) {
      this.loading = true
      const searchString = searchText
      let url = `${
        this.params.colDef['cellRendererParams'].dropdownURL
      }${searchText.slice(0, 3)}`
      if (this.params.colDef.cellRendererParams.screen === 'Project') {
        url = `${projectAPIs.master.takeoff.add(
          this.$route.params.id,
        )}?search=${searchText.slice(0, 3)}`
      }
      if (
        (this.prevSearchKey !== searchText && searchText.length === 3) ||
        (!this.prevSearchKey && searchText.length >= 3)
      ) {
        this.currentResult = []
        this.prevSearchKey = searchText
        instance
          .get(`${url}`)
          .then(res => {
            const result = _.get(res.data, 'result', [])
            this.list = []
            this.prevResult = JSON.stringify(result)
            const oldData =
              this.prevResult.length > 0 && searchString
                ? JSON.parse(this.prevResult)
                : []
            this.searchTakeoffs(oldData, searchString)
          })
          .catch(err => {
            this.loading = false
            errorService(err)
          })
      } else {
        const oldData =
          this.prevResult.length > 0 && searchText
            ? JSON.parse(this.prevResult)
            : []

        this.searchTakeoffs(oldData, searchString)
      }
    },

    searchTakeoff(oldData, searchString) {
      const filterData = filterTakeoff(oldData, searchString, this.limit)
      this.count = filterData.count
      this.currentResult = filterData.currentResult
      this.loading = false
    },

    searchTakeoffs(oldData, searchString) {
      const filterData = filterGrid(oldData, searchString, this.limit)
      this.count = filterData.count
      this.currentResult = filterData.currentResult
      this.list = filterData.list
      this.loading = false
      if (this.gridOptions.api) {
        this.gridOptions.api.setRowData(this.list)
      }
    },

    saveData(value) {
      if (value !== 'viewAll') {
        this.currentResult.forEach(data => {
          data.takeoffs.forEach(takeoff => {
            if (takeoff.key === value) {
              this.takeoffData = takeoff
              this.value = takeoff.takeoffKey
            }
          })
        })
        const key = value === 'new' ? undefined : this.takeoffData.id
        this.value = value === 'new' ? window.previousValue : value
        switch (this.params.colDef.cellRendererParams.type) {
          case 'dynamicTable':
            this.$root.$emit(
              'handleChange',
              value === 'new' ? value : this.takeoffData.takeoff,
              this.params.data,
              this.params.colDef.field,
              this.params.rowIndex,
              this.takeoffData,
            )
            break
          case 'analysisSheet':
            this.$root.$emit(
              'saveAnalysisData',
              value === 'new' ? value : this.takeoffData.takeoff,
              this.params.data,
              this.params.colDef.field,
              this.params.data.columnId,
              this.takeoffData,
              value === 'new' ? null : this.takeoffData.takeoffGrouping,
            )
            break
          case 'actualCostLevel':
            this.$root.$emit(
              'handleTileChange',
              value === 'new' ? value : this.takeoffData.takeoff,
              this.params.data,
              this.params.colDef.field,
              this.params.data.columnId,
              this.takeoffData,
              value === 'new' ? null : this.takeoffData.takeoffGrouping,
            )
            break
          case 'estimateGroup':
            this.$root.$emit(
              `onUpdateTakeoff${this.params.data.assetId}`,
              value === 'new' ? value : this.takeoffData.takeoff,
              this.params.data,
              this.params.colDef.field,
              this.params.rowIndex,
              this.takeoffData,
            )
            break
          case 'estimateTakeoff':
            this.$root.$emit(
              'onUpdateTakeoffs',
              value === 'new' ? value : this.takeoffData.takeoff,
              this.params.data,
              this.params.colDef.field,
              this.params.rowIndex,
              this.takeoffData,
            )
            break
          default:
            this.$root.$emit(
              'saveTenantData',
              this.params.colDef.field,
              value === 'new' ? value : this.takeoffData.takeoff,
              this.params.colDef.headerName,
              this.params.data,
              key,
            )
            break
        }
      } else {
        this.visible = true
        this.getTakeoffs(this.prevSearchKey)
      }
    },

    formatCurrency(value) {
      const settings = JSON.parse(localStorage.getItem('userSettings'))
      return new Intl.NumberFormat(settings.currency.currencyFormate, {
        style: 'currency',
        currency: settings.currency.currency,
      }).format(value)
    },

    formatLife(value) {
      if (value > 1) {
        return `${value} Years`
      } else {
        return `${value} Year`
      }
    },

    handleOk() {
      this.visible = false
      this.value = this.searchText
    },

    handleCancel() {
      this.visible = false
      this.value = this.searchText
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data)
      this.visible = false
      this.value = selectedData[0].takeoff
      switch (this.params.colDef.cellRendererParams.type) {
        case 'dynamicTable':
          this.$root.$emit(
            'handleChange',
            selectedData[0].takeoff,
            this.params.data,
            this.params.colDef.field,
            this.params.rowIndex,
            selectedData[0],
          )
          break
        case 'analysisSheet':
          this.$root.$emit(
            'saveAnalysisData',
            selectedData[0].takeoff,
            this.params.data,
            this.params.colDef.field,
            this.params.rowIndex,
            selectedData[0],
          )
          break
        case 'actualCostLevel':
          this.$root.$emit(
            'handleTileChange',
            selectedData[0].takeoff,
            this.params.data,
            this.params.colDef.field,
            this.params.data.columnId,
            selectedData[0],
            selectedData[0].takeoffGrouping,
          )
          break
        case 'estimateGroup':
          this.$root.$emit(
            `onUpdateTakeoff${this.params.data.assetId}`,
            selectedData[0].takeoff,
            this.params.data,
            this.params.colDef.field,
            this.params.rowIndex,
            selectedData[0],
          )
          break
        case 'estimateTakeoff':
          this.$root.$emit(
            'onUpdateTakeoffs',
            selectedData[0].takeoff,
            this.params.data,
            this.params.colDef.field,
            this.params.rowIndex,
            selectedData[0],
          )
          break
        default:
          this.$root.$emit(
            'handleChange',
            selectedData[0].takeoff,
            this.params.data,
            this.params.colDef.field,
            this.params.rowIndex,
            selectedData[0],
          )
          break
      }
    },

    clearFilter() {
      this.prevSearchKey = undefined
      this.prevResult = []
      this.currentResult = []
      this.takeoffData = null
      this.list = []
      this.count = 0
      this.searchText = undefined
      this.gridOptions.api.setRowData([])
    },

    getValue() {
      if (this.takeoffData) {
        return this.takeoffData.takeoff
      } else {
        return this.value
      }
    },
  },
})
